import { defineMessages } from 'react-intl';

const translations = {
  addressFormSection: {
    billing: {
      title: {
        id: 'pages.addressFormSection.billing.title',
        defaultMessage: 'Billing address',
        description: 'Title of the billing address form section',
      },
    },
    target: {
      title: {
        id: 'pages.addressFormSection.target.title',
        defaultMessage: 'To',
        description: 'Title of the target address form section',
      },
    },
    source: {
      title: {
        id: 'pages.addressFormSection.source.title',
        defaultMessage: 'From',
        description: 'Title of the source address form section',
      },
    },
  },
  formActions: {
    save: {
      id: 'formActions.save',
      defaultMessage: 'Save',
      description: 'Label of the form action save',
    },
    saveWithoutCalculation: {
      id: 'formActions.saveWithoutCalculation',
      defaultMessage: 'Save without calculation',
      description: 'Label of the form action save without calculation',
    },
  },
  feedback: {
    calculationNotCreated: {
      id: 'orderForm.feedback.calculationNotCreated',
      defaultMessage: 'Calculation could not be created',
      description: 'Error message of the save with calculation action',
    },
  },
  createCalculationProgressDialog: {
    message: {
      id: 'orderForm.createCalculationProgressDialog.message',
      defaultMessage: 'Creating calculation',
      description: 'Progress message of the create calculation action',
    },
  },
};

export default defineMessages(translations);
